import React from 'react'
import { Card, CardContent, IconButton, Collapse, styled, CardHeader } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    marginLeft: 'auto',
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));


const CustomCard = ({ title, children }) => {
    const [expanded, setExpanded] = React.useState(true);
    const handleExpandClick = () => setExpanded(!expanded);

    return (
        <Card sx={{ margin: 0 }} variant="outlined">
            <CardHeader
                title={title}
                titleTypographyProps={{
                    variant: "h4",
                    fontSize: 18,
                    fontWeight: "600",
                }}
                // subheader="September 14, 2016"
                action={
                    <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more">
                        <ExpandMoreIcon />
                    </ExpandMore>
                }
            />
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                    {children}
                </CardContent>
            </Collapse>
        </Card>
    );
}

export default CustomCard